class Cart extends HTMLElement {
  connectedCallback() {
    this.Cart = this;
    this.isCartPage = document.body.classList.contains("template-cart");
    this.hasFreeProductBeenRemoved = false;
    this.hasFreeGiftPackageBeenRemoved = false;
    this.initCart();
  }
  initCart() {
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        document.body.classList.add("cart-is-updating");
        this.getSectionsToRender().forEach((section) => {
          fetch(`${routes.cart_url}?section_id=${section.id}`).then((response) => response.text()).then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            const element = html.querySelector(section.selector);
            document.querySelector(section.selector).innerHTML = element.innerHTML;
          }).catch((e) => {
            document.body.classList.remove("cart-is-updating");
            console.error(e);
          });
        });
        document.body.classList.remove("cart-is-updating");
      }
    });
  }
  updateCart(response) {
    document.body.classList.add("cart-is-updating");
    this.getSectionsToRender().forEach((section) => {
      document.querySelector(section.selector).innerHTML = this.getSectionInnerHTML(
        response.sections[section.id],
        section.selector
      );
    });
    document.body.classList.remove("cart-is-updating");
    window.lozadObserver.observe();
  }
  getSectionsToRender() {
    if (this.isCartPage) {
      return [
        {
          id: "main-cart",
          // match liquid file section main-cart.liquid
          selector: ".main-cart"
        },
        {
          id: "cart-icon-bubble",
          // match liquid file section cart-icon-bubble.liquid
          selector: "#cart-icon-bubble"
        }
      ];
    } else {
      return [
        {
          id: "drawer-cart",
          // match liquid file section drawer-cart.liquid
          selector: "drawer-cart .cart-icon-bubble"
        },
        {
          id: "drawer-cart",
          // match liquid file section drawer-cart.liquid
          selector: "drawer-cart .drawer__content"
        },
        {
          id: "drawer-cart",
          // match liquid file section drawer-cart.liquid
          selector: "drawer-cart .drawer__footer"
        },
        {
          id: "cart-icon-bubble",
          // match liquid file section cart-icon-bubble.liquid
          selector: "#cart-icon-bubble"
        }
      ];
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  displayErrorMessage(error) {
    this.cartError = this.querySelector(".js-cart-error-message");
    if (this.cartError && error) {
      this.cartError.classList.add("visible");
      this.cartError.querySelector(".js-cart-error-text").innerHTML = error;
    }
  }
}
customElements.define("w3-cart", Cart);
class CartItems extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.CartItems = this;
    this.Cart = this.closest("w3-cart");
    this.isFreeProductEligible = this.CartItems.hasAttribute("free-product-eligible");
    this.isFreeProductNoLongerEligible = this.CartItems.hasAttribute("free-product-no-longer-eligible");
    this.isGiftPackageActive = this.CartItems.hasAttribute("gift-package-active");
    this.isGiftPackageToUpdate = this.CartItems.hasAttribute("gift-package-to-update");
    this.isGiftPackageAdd = this.CartItems.hasAttribute("gift-package-to-add");
    if (this.isFreeProductEligible && !this.Cart.hasFreeProductBeenRemoved) {
      this.CartItems.addQuantity(this.CartItems.dataset.freeProductId, 1);
    }
    if (this.isGiftPackageActive && this.isGiftPackageToUpdate) {
      const variant_id = this.CartItems.dataset.giftPackageId;
      const target_quantity = this.CartItems.dataset.giftPackageQuantity;
      if (variant_id && target_quantity) {
        this.Cart.canGiftPackageBeUpdated = false;
        this.CartItems.updateQuantity(null, variant_id, target_quantity);
      }
    }
    if (this.isGiftPackageActive && this.isGiftPackageAdd) {
      const variant_id = this.CartItems.dataset.giftPackageId;
      const target_quantity = this.CartItems.dataset.giftPackageQuantity;
      if (variant_id && target_quantity) {
        this.Cart.canGiftPackageBeUpdated = false;
        this.CartItems.addQuantity(variant_id, target_quantity);
      }
    }
  }
  addQuantity(id, quantity) {
    document.body.classList.add("cart-is-updating");
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.Cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } }).then((response) => response.json()).then((response) => {
      if (response.errors) {
        this.Cart.displayErrorMessage(response.errors);
        document.body.classList.remove("cart-is-updating");
        return;
      }
      this.Cart.updateCart(response);
    }).finally(() => {
      document.body.classList.remove("cart-is-updating");
      window.lozadObserver.observe();
    }).catch((e) => {
      console.error(e);
      document.body.classList.add("cart-is-updating");
    });
  }
  updateQuantity(line, variant_id, quantity) {
    this.Cart = document.querySelector("w3-cart");
    document.body.classList.add("cart-is-updating");
    let params = {
      quantity,
      sections: this.Cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    };
    if (line) {
      params.line = line;
    } else if (variant_id) {
      params.id = variant_id;
    }
    let body = JSON.stringify(params);
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } }).then((response) => response.json()).then((response) => {
      if (response.errors) {
        this.Cart.displayErrorMessage(response.errors);
        document.body.classList.remove("cart-is-updating");
        return;
      }
      this.Cart.updateCart(response);
    }).finally(() => {
      document.body.classList.remove("cart-is-updating");
      window.lozadObserver.observe();
    }).catch((e) => {
      console.error(e);
      document.body.classList.add("cart-is-updating");
    });
  }
}
customElements.define("w3-cart-items", CartItems);
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      if (event.target.closest("cart-free-product")) {
        const Cart2 = this.closest("w3-cart");
        Cart2.hasFreeProductBeenRemoved = true;
      }
      const CartItems2 = this.closest("w3-cart-items");
      CartItems2.updateQuantity(this.dataset.index, null, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartUpdateQuantity extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const quantity = parseInt(this.dataset.currentQuantity) + parseInt(this.dataset.targetQuantity);
      const cartItems = this.closest("w3-cart-items");
      cartItems.updateQuantity(this.dataset.index, null, quantity);
    });
  }
}
customElements.define("cart-update-quantity-button", CartUpdateQuantity);
class CartShippingButton extends HTMLElement {
  constructor() {
    super();
    this.cartShippingButton = this;
    this.cartShipping = document.querySelector(".js-cart-shipping");
    if (this.cartShippingButton && this.cartShipping) {
      this.cartShippingButton.addEventListener("click", () => {
        this.cartShipping.classList.toggle("active");
      });
    }
  }
}
customElements.define("cart-shipping-button", CartShippingButton);
class CartFreeProduct extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const cartItems = this.closest("w3-cart-items");
    if (cartItems.isFreeProductNoLongerEligible) {
      cartItems.updateQuantity(this.dataset.index, null, 0);
    }
  }
}
customElements.define("cart-free-product", CartFreeProduct);
class CartPackageCheckbox extends HTMLElement {
  constructor() {
    super();
    this.initPackageAddToCart();
  }
  initPackageAddToCart() {
    this.checkbox = this.querySelector(".js-cart-add-package-checkbox");
    this.checkbox.addEventListener("change", (e) => {
      if (e.target.checked === true) {
        const packageAddButton = this.querySelector("#product-package-add-to-cart");
        packageAddButton.click();
      }
    });
  }
}
customElements.define("cart-package-checkbox", CartPackageCheckbox);
class CartGiftPackageRemove extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.Cart = this.closest("w3-cart");
    this.giftPackageSmallVariantId = this.dataset.giftPackageSmallVariantId;
    this.giftPackageMediumVariantId = this.dataset.giftPackageMediumVariantId;
    this.giftPackageLargeVariantId = this.dataset.giftPackageLargeVariantId;
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.removeGiftPackages();
    });
  }
  removeGiftPackages() {
    document.body.classList.add("cart-is-updating");
    let updates = {};
    if (this.giftPackageSmallVariantId) {
      updates[this.giftPackageSmallVariantId] = 0;
    }
    if (this.giftPackageMediumVariantId) {
      updates[this.giftPackageMediumVariantId] = 0;
    }
    if (this.giftPackageLargeVariantId) {
      updates[this.giftPackageLargeVariantId] = 0;
    }
    let params = {
      updates,
      sections: this.Cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    };
    let body = JSON.stringify(params);
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then((response) => response.json()).then((response) => {
      if (response.errors) {
        this.Cart.displayErrorMessage(response.errors);
        document.body.classList.remove("cart-is-updating");
        return;
      }
      this.Cart.hasFreeGiftPackageBeenRemoved = true;
      this.Cart.updateCart(response);
    }).finally(() => {
      document.body.classList.remove("cart-is-updating");
      window.lozadObserver.observe();
    }).catch((e) => {
      console.error(e);
      document.body.classList.add("cart-is-updating");
    });
  }
}
customElements.define("cart-gift-package-remove", CartGiftPackageRemove);
